/**
 * Store de alarmas
 * --------------------------------------------
 */
export default {
  namespaced: true,
  state: {
    alarms: [{ name: "test" }],
  },
  mutations: {},
  actions: {},
  getters: {},
};
